module.exports = __webpack_public_path__ + "Floorplan_Studio_1.f6c1873d.pdf";


//////////////////
// WEBPACK FOOTER
// ./client/download/Floorplan_Studio_1.pdf
// module id = 475
// module chunks = 0